import gql from 'graphql-tag';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';

/**
 * Data of the block project-measurement-report-build ("Aufmaßprotokoll: Bericht generieren"): the
 * generated PDF, the ZIP of the measurement photos and their build states. Read through
 * `Project.blocks.measurementReportBuild`, which checks the block's read permission.
 */
export const PROJECT_MEASUREMENT_REPORT_BUILD_FIELDS = gql`
  fragment projectMeasurementReportBuildFields on ProjectMeasurementReportBuildBlock {
    id
    number
    measurementReportAttachments {
      ${ATTACHMENT_FIELDS}
    }
    measurementReportAttachmentsBuildState
    measurementReportImageAttachmentsZip {
      ${ATTACHMENT_FIELDS}
    }
    measurementReportImageAttachmentsZipBuildState
  }
`;
